import L from 'leaflet';
import {GestureHandling} from 'leaflet-gesture-handling';

L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);

// Fix from here: https://github.com/KoRiGaN/Vue2Leaflet/issues/28
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.imagePath = skeleton_script_main.theme_url + '/assets/images/';
// L.Icon.Default.mergeOptions({
//     iconUrl:        L.Icon.Default.imagePath + 'pin.svg',
//     iconSize:       [37, 48],
//     iconAnchor:     [18.5, 48],
//     shadowUrl:      L.Icon.Default.imagePath + 'pin-shadow.svg',
//     shadowSize:     [37, 48],
//     shadowAnchor:   [18.5, 48],
//     popupAnchor:    [0, -48],
// });

var maps = document.querySelectorAll('.leaflet-map'),
    padding = 100,
    paddingTop = padding,
    paddingLeft = padding;

for (var i = 0; i < maps.length; i++) {

    var mapWrapper = maps[i],
        mapContainer = mapWrapper.querySelector('.map-container'),
        options = JSON.parse(mapWrapper.dataset.options),
        customIcon = null,
        map = L.map(mapContainer, {
            gestureHandling: true,
            scrollWheelZoom: true,
            zoomControl: false,
            dragging: true,
        });

    // var container = mapWrapper.querySelector('.section-container');

    // if( typeof container !== 'undefined' && window.matchMedia('(min-width:768px)').matches ) {

    //     var content = container.querySelector('.section-width');

    //     if( container.classList.contains('justify-content-start') ) {
    //         paddingLeft = paddingLeft + content.offsetWidth;
    //     }

    //     if( container.classList.contains('justify-content-end') ) {
    //         paddingLeft = paddingLeft - content.offsetWidth;
    //     }

    // }

    if (mapContainer.classList.contains('justify-content-start') ) {
        paddingLeft = paddingLeft + mapContainer.offsetWidth;
    }

    if (mapContainer.classList.contains('justify-content-end') ) {
        paddingLeft = paddingLeft - mapContainer.offsetWidth;
    }

    L.Icon.Default.mergeOptions({
        imagePath: main_js_vars.asset_url,
        iconUrl: require('leaflet/dist/images/marker-icon.png'),
        iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
        shadowUrl: null,
        shadowRetinaUrl: null,
        shadowSize: [0, 0],
    });

    if (options.icon) {

        var iconWidth = 48,
            iconHeight = 48,
            iconAnchor = [iconWidth / 2, iconHeight],
            popupAnchor = [0, -iconHeight * 0.6];

        customIcon = L.icon({
            iconUrl: options.icon,
            iconSize: [iconWidth, iconHeight],
            iconAnchor: iconAnchor,
            popupAnchor: popupAnchor,
        });
    }

    // if (options.zoom_position) {
    //     L.control.zoom({
    //         position: options.zoom_position
    //     }).addTo(map);
    // }

    L.tileLayer('https://api.mapbox.com/styles/v1/{style}/tiles/{z}/{x}/{y}?access_token={token}', {
        attribution: '© <a href="https://www.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        detectRetina: true,
        tileSize: 512,
        zoomOffset: -1,
        style: options.style,
        token: options.token
    }).addTo(map);

    var bounds = [],
        markers = mapWrapper.querySelectorAll('.marker');

    for (var m = 0; m < markers.length; m++) {

        var marker = JSON.parse(markers[m].dataset.marker),
            label = marker.label,
            coords = L.latLng(parseFloat(marker.latitude), parseFloat(marker.longitude)),
            markerOptions = {};

        if (customIcon) {
            markerOptions = {
                icon: customIcon
            };
        }

        var marker = L.marker(coords, markerOptions);

        if (label && options.popup) {
            marker.bindPopup(label, {
                className: 'map-marker-popup',
                keepInView: true,
                // minWidth:   250,
                // maxWidth:   400,
            });
        }

        bounds.push(coords);
        marker.addTo(map);
    }

    if (markers.length > 0) {
        map.fitBounds(L.latLngBounds(bounds), {
            paddingTopLeft: [paddingLeft, paddingTop],
            paddingBottomRight: [padding, padding],
            maxZoom: options.zoom,
        });
    }

    // var centerPoint  = map.getSize().divideBy(2),
    //     targetPoint  = centerPoint.subtract([0, headerOffset]),
    //     targetLatLng = map.containerPointToLatLng(targetPoint);

    // map.panTo(targetLatLng);

}
